import React from 'react';
import PrintComponents from "react-print-components";
import LogoBlue from '../../../assets/image/logo_blue.png';
import moment from "moment/moment";

const PrintResidueDocument = ({ printData, company, date }) => {
    if (!printData) return null;

    return (
        <div style={{ display: 'none' }}>
            <PrintComponents
                trigger={
                    <button id="print_button_residue" className="print_btn">
                        Печать
                    </button>
                }
            >
                <div className="print_goods">
                    <div className="print_goods__header">
                        <div className="print_goods__header--logo">
                            <img src={LogoBlue} alt="Logo" />
                        </div>
                        <div className="print_goods__header--company">
                            {company}
                        </div>
                    </div>
                    <div className="print_goods__date">
                        <span>{moment(date).format("DD.MM.YYYY HH:mm")}</span>
                    </div>
                    <div className="new_issue_table">
                        <div className="table_container transactions_columns">
                            <div className="table_header">
                                <div className="table_row">
                                    <div className="row_item">Название</div>
                                    <div className="row_item">Артикул</div>
                                    <div className="row_item">Производитель</div>
                                    <div className="row_item">К-во товара</div>
                                    <div className="row_item">Цена</div>
                                    <div className="row_item">Сумма</div>
                                </div>
                            </div>
                            <div className="table_body">
                                {printData.map((order, idx) => (
                                    <div className="table_row" key={idx}>
                                        <div className="row_item">{order.name}</div>
                                        <div className="row_item">{order.article_number}</div>
                                        <div className="row_item">{order.producer}</div>
                                        <div className="row_item">{order.amount}</div>
                                        <div className="row_item">{order.price.toFixed(2)}</div>
                                        <div className="row_item">{(order.price * order.amount).toFixed(2)}</div>
                                    </div>
                                ))}
                            </div>
                            <div className="table_container__summary">
                                Итого:{" "}
                                {printData
                                    .reduce(
                                        (sum, order) => sum + order.price * order.amount,
                                        0
                                    )
                                    .toFixed(2)}
                            </div>
                        </div>
                    </div>
                </div>
            </PrintComponents>
        </div>
    );
};

export default PrintResidueDocument;

